module.exports = __webpack_public_path__ + "media/images/icons/clock-dd3ee0f512a2d9442a257183a430c47c.png";